import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetContainer from '~shared/ui/WidgetContainer';
import { getGaAttributeValueInplay } from '~shared/utils/google-analytics';
import { orderSportMarketHeaders } from '~scenes/inplay/components/utils';
import { seoUrlInplay } from '~spa/Utils/SeoUrls';
import InplayWidgetEvent from './InplayWidgetEvent';
import '~shared/components/react/SportsWidget/styles/sports-widget.scss';
import '~shared/components/content-section/styles.scss';
import '~scenes/inplay/components/styles/column-labels.scss';
import './styles/InplayWidget.scss';

const InplayWidget = ({
    events = [],
    markets = {},
    markets_headers: marketsHeaders = {},
    selections = {},
    titleIconClassName = 'inplay',
    titleLink = null,
    showFooter = false,
    source,
}) => {
    const { t } = useTranslation();

    if (events.length === 0 || Object.keys(selections).length === 0) {
        return null;
    }

    const renderBetCards = () => {
        const group = [];

        return events.map((event, index) => {
            const {
                id: eventId,
                sport_slug: sportSlug,
                sport_name: sportName,
                default_market_headers: defaultMarketHeaders = {},
                sport_columns: sportColumns,
                usesThreeMarketView,
            } = event;
            const showDividerHeader = !group.includes(sportName);
            const orderedMarketHeaders = orderSportMarketHeaders(defaultMarketHeaders, usesThreeMarketView ? 3 : sportColumns);
            const headerClassNames = classNames(
                'bb-inplay-widget__sport-header',
                'bb-content-section__title',
                'bb-content-section__title--tertiary',
                {
                    'bb-inplay-widget__sport-header--three-markets': usesThreeMarketView,
                    'bb-inplay-widget__sport-header--no-sport-name': source === sportSlug,
                }
            );

            group.push(sportName);

            return (<Fragment key={index}>
            {
                showDividerHeader
                ? <div key={sportName} className={headerClassNames}>
                        {(source !== sportSlug) ? sportName : null}
                        <div className='bb-inplay-sport__column-labels bb-inplay-sport__column-labels__three-market-view'>
                            {
                                orderedMarketHeaders.map((headerName, index) => (
                                    <div key={index} className='bb-inplay-sport__column-label'>
                                        {t(`mkt_headers.${headerName.toLowerCase()}`, ' ')}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                : null
            }
                <InplayWidgetEvent
                    key={eventId}
                    event={event}
                    markets={markets[eventId] || {}}
                    marketsHeaders={marketsHeaders}
                    selections={selections[eventId] || []}
                    source={source}
                />
            </Fragment>);
        });
    };

    return (
        <div className="featured-matches-widget bb-inplay-widget">
            <WidgetContainer
                title={t('inplay.featured_ip')}
                titleIconClassName={titleIconClassName}
                titleLink={showFooter ? (titleLink ?? seoUrlInplay()) : null}
                gtmAttribute={`${source};inplay-widget;see-all`}
                gaComponent={getGaAttributeValueInplay('featured')}
            >
                {renderBetCards()}
            </WidgetContainer>
        </div>
    );
};

InplayWidget.propTypes = {
    events: PropTypes.array,
    markets: PropTypes.object,
    selections: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    showFooter: PropTypes.bool,
    markets_headers: PropTypes.object,
    baseInplayLink: PropTypes.string,
    mainClassName: PropTypes.string,
    titleIconClassName: PropTypes.string,
    source: PropTypes.string,
    titleLink: PropTypes.string,
};

export default InplayWidget;
